import { TCutbankInState } from './cutbank-in-db.models';
import { TCutbankInActions } from './cutbank-in-db.actions';

export const cutbankInStoreInitalState: TCutbankInState = {
  subjects: [],
  isComponentBundleScanEnabled: false,
  transactionLogInfo: null,
  activityLogInfo: null,
};

export function cutbankInStoreStateReducer(
  state: TCutbankInState = cutbankInStoreInitalState,
  action: TCutbankInActions,
): TCutbankInState {
  switch (action.type) {
    case 'GET_SUBJECT_LIST_CUTBANK_IN_SUCCESS':
      return {
        ...state,
        subjects: action.cutbankInRes,
      };

    case 'GET_TRANSACTION_LOG_CUTBANK_IN_SUCCESS':
      return {
        ...state,
        transactionLogInfo: action.transactionLog,
      };
    case 'GET_ACTIVITY_LOG_CUTBANK_IN_SUCCESS':
      return {
        ...state,
        activityLogInfo: action.activityLog,
      };
    case 'IS_COMPONENT_BUNDLE_SCAN_ENABLED_CUTBANK_IN_SUCCESS':
      return {
        ...state,
        isComponentBundleScanEnabled: action.isComponentBundleScanEnabled,
      };
    default:
      return state;
  }
}
